import React, { Component } from 'react'
import {Link, navigate} from 'gatsby'
import { Search } from 'semantic-ui-react'
import * as styles from './styles/searchBar.module.css'
import {searchBarColor} from '../../globalVar'
import { SearchContext } from '../Context/SearchContext'

//const Negosyo = require('../../../lib/negosyo')
// const Logger = require('../../../lib/logger')

const initialState = { isLoading: false, results: [], value: '' }

export default class SearchBar extends Component {
	state = initialState
	static contextType = SearchContext;


	handleKeyPress = (event) => {
		if(event.key==="Enter") {
			this.handleButtonClick();
		}
	}

	handleButtonClick = (event) => {
		const searchValue = this.context.data;
		if (searchValue.length > 0 ) {
			this.setState({value: searchValue})
			const searchQuery = encodeURIComponent(searchValue);
			navigate(`/search/?search_query=${searchQuery}`)
		}
	}

	handleSearchChange = (e, { value }) => {
		/*isLoading: true, previously in setState but took it out since there's still problems with the results
		 *not having a scroll and for mobile not having a scroll and positioning
		 */
		this.setState({  value }, ()=>{
			if (this.state.value.length < 1) {
				this.setState(initialState)
			}else {
				/*
				Negosyo.getProductSearchText(this.state.value).then((response)=> {
					const temp = response.map(this.mapNegosyoResults)

					this.setState({
						isLoading: false,
						results:temp
					})
				}).catch((err)=> {
					//Logger.log(err);
				})
				*/
			}
		})
		this.context.updateData(value)
	}

	mapNegosyoResults = ({name, mainImageHref, description, meta, id}) => {
		return (
			{
				as:Link,
				to:`/product/${id}/`,
				title:name,
				image:mainImageHref,
				description:description.length > 50 ? `${description.substring(0,50)}...`:description,
				price:`${meta.display_price.with_tax.currency}${meta.display_price.with_tax.amount}`,
			}

		)
	}

	render() {
		const { isLoading, value, results } = this.state
		const searchValue = this.context.data;
		return (
			<Search
				input={{
					className:styles.inputComputerHome,
					input:<input type="text" ></input>,
					action:{
						color:searchBarColor,
						icon:'search',
						loading:isLoading,
						onClick:this.handleButtonClick
					},
					placeholder:"Search NegosyoNow"
				}}
				icon={{
					name:'',
				}}
				onSearchChange={this.handleSearchChange}
				results={results}
				value={searchValue}
				className={styles.input}
				onKeyPress={this.handleKeyPress}
				showNoResults={false}
			/>
		)
	}
}

